/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'react',
	'prop-types',
	'ca-ui-toolkit',
	'./CustomPreviewWidgetsComponent',
	'./CustomVisualsComponent'
], function(
	React,
	PropTypes,
	UI_Toolkit,
	CustomPreviewWidgetsComponent,
	CustomVisualsComponent
) {

	const { Component } = React;
	const { Container, FlexLayout, FlexItem, VSpacer } = UI_Toolkit;

	class CustomPanelContainer extends Component {
		constructor(props) {
			super(props);

			this.state = {
				previewItems: this.props.custom.preview.previewItems,
				items: this.props.custom.visuals.items,
				isRefreshing: this.props.isRefreshing
			};
		}

		componentWillReceiveProps(nextProps) {
			this.setState({
				previewItems: nextProps.custom.preview.previewItems,
				items: nextProps.custom.visuals.items,
				isRefreshing: nextProps.isRefreshing
			});
		}

		render () {
			// potential change here
			const { customVisAction } = this.props;
			const { previewItems, items, isRefreshing } = this.state;
			const canDevelop = customVisAction.canDevelop();
			const className = 'vis-custom-container' + (canDevelop ? '' : ' no-preview');

			return (
				<Container
					className={className}
				>
					<FlexLayout
						fullHeight
						direction="column"
					>
						{canDevelop && (
							<FlexItem className='vis-custom-preview-container'>
								<CustomPreviewWidgetsComponent
									previewItems={previewItems}
									handlers={this.props.handlers}
									dashboardApi={this.props.dashboardApi}
								/>
							</FlexItem>
						)}
						{customVisAction.canManageOnly() && (
							<FlexItem>
								<VSpacer size={2} />
							</FlexItem>
						)}
						<FlexItem
							basis={'0%'}
							grow={1}
							shrink={1}
						>
							<CustomVisualsComponent
								items={items}
								handlers={this.props.handlers}
								dashboardApi={this.props.dashboardApi}
								customVisAction={this.props.customVisAction}
								isRefreshing={isRefreshing}
							/>
						</FlexItem>
					</FlexLayout>
				</Container>
			);
		}
	}

	CustomPanelContainer.propTypes = {
		custom: PropTypes.shape({
			preview: PropTypes.shape({
				previewItems: PropTypes.array
			}).isRequired,
			visuals: PropTypes.shape({
				items: PropTypes.array.isRequired
			}).isRequired
		}).isRequired,
		handlers:  PropTypes.object.isRequired,
		isRefreshing: PropTypes.bool,
		dashboardApi: PropTypes.object.isRequired,
		customVisAction: PropTypes.object.isRequired
	};

	CustomPanelContainer.defaultProps = {
		isRefreshing: false
	};

	return CustomPanelContainer;
});
